<template>
  <div class="enjoy-area pt-100">
    <div class="container">
      <div class="row align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="enjoy-img">
            <img src="@/assets/images/enjoy.png" alt="enjoy" />
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="enjoy-content">
            <span class="top-title">استمتع</span>
            <h2>شاهد الرياضة، الأفلام، القنوات التلفزيونية والمزيد</h2>
            <p>
              مع مجموعتنا الضخمة والشاملة من القنوات التلفزيونية، لن تفوتك أبداً 
              مبارياتك الرياضية المفضلة وبرامجك التلفزيونية العربية والعالمية.
            </p>
            <h4>اشترك الآن واحصل على دعم فني احترافي ومباشر</h4>
            <div class="row align-items-center mb-30">
              <div class="col-lg-4 col-sm-6">
                <div class="starting-form mb-sm-0">
                  <span>تبدأ من</span>
                  <h1>$ 49.99<sub>/ شهرياً</sub></h1>
                </div>
              </div>
              <div class="col-lg-8 col-sm-6">
                <div class="nestor-prepaid">
                  <span>باقات IPTV المميزة</span>
                  <h3>اختر الباقة التي تناسب احتياجاتك الترفيهية</h3>
                  <RouterLink
                    to="/about-us"
                    class="read-more style-two text-grey-teal"
                  >
                    اعرف المزيد
                    <i class="ti ti-arrow-right"></i>
                  </RouterLink>
                </div>
              </div>
            </div>
            <RouterLink to="/pricing-plan" class="btn bg-grey-teal">
              <span class="border-style">عرض جميع باقات الاشتراك</span>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  // تم تغيير الاسم إلى اسم متعدد الكلمات لتجنب خطأ ESLint
  name: "EnjoyStreaming",
});
</script>